import { ActionCreators as UndoActionCreators } from 'redux-undo'
import PoolsApi from '../api/pools'
import { addInfoNotification, addErrorNotification } from './notifications'

export const SHIFTS_GOTO_EDIT_MODE = 'shifts/GOTO_EDIT_MODE'
export const LOADSHIFTS_REQUESTED = 'shifts/LOADSHIFTS_REQUESTED'
export const SHIFTS_LOADED = 'shifts/SHIFTS_LOADED'
export const LOADSHIFTS_ERROR = 'shifts/LOADSHIFTS_ERROR'
export const SHIFT_ON_CHANGE = 'shifts/SHIFT_ON_CHANGE'
export const SAVESHIFTS_REQUESTED = 'shifts/SAVESHIFTS_REQUESTED'
export const SHIFTS_SAVED = 'shifts/SHIFTS_SAVED'
export const SAVESHIFTS_ERROR = 'shifts/SAVESHIFTS_ERROR'
export const ADD_SHIFT = 'shifts/ADD_SHIFT'

export const gotoEditMode = (editMode) => {
  return (dispatch, getState) => {
    if (!editMode && getState().shifts.past.length > 0) {
      dispatch(UndoActionCreators.jumpToPast(0))
      dispatch(UndoActionCreators.clearHistory())
    }
    dispatch({
      type: SHIFTS_GOTO_EDIT_MODE,
      editMode: editMode
    })
  }
}

export const loadShiftsAsync = (poolId) => {
  return dispatch => {
    dispatch({
      type: LOADSHIFTS_REQUESTED,
      poolId: poolId
    })

    return PoolsApi.GetShifts(poolId, 0)
      .then(response => response.json())
      .then(json => dispatch(shiftsLoaded(json)))
      .catch(error => {
        dispatch({
          type: LOADSHIFTS_ERROR,
          error: error.message
        })
        console.log('There has been a problem with your fetch operation: ', error)
      })
  }
}

const shiftsLoaded = (data) => {
  return {
    type: SHIFTS_LOADED,
    data: data
  }
}

export const shiftOnChange = (shift) => {
  return dispatch => dispatch({
    type: SHIFT_ON_CHANGE,
    shift: shift
  })
}

export const saveChangedShiftsAsync = (poolId, shifts) => {
  return dispatch => {
    dispatch({
      type: SAVESHIFTS_REQUESTED,
      poolId: poolId
    })

    const shiftsOverride = shifts.filter(item => !item.deleted)

    PoolsApi.SaveShifts(poolId, shiftsOverride)
      .then(response => {
        if (response.ok) {
          dispatch(UndoActionCreators.clearHistory())
          dispatch(gotoEditMode(false))
          dispatch(shiftsSaved(shiftsOverride))
          dispatch(addInfoNotification('Shifts Saved'))
        }
        else {
          dispatch({
            type: SAVESHIFTS_ERROR,
            error: response.statusText
          })
          dispatch(addErrorNotification('Error saving shifts', response.statusText))
          console.log('Fetch error response: ', response)
        }
      })
      .catch(error => {
        dispatch({
          type: SAVESHIFTS_ERROR,
          error: error.message
        })
        dispatch(addErrorNotification('Error saving shifts', error.message))
        console.log('Catch fetch error: ', error)
      })
  }
}

const shiftsSaved = shiftsOverride => {
  return {
    type: SHIFTS_SAVED,
    message: "Success",
    shifts: shiftsOverride
  }
}

export const addShift = activeDate => {
  return dispatch => dispatch({
    type: ADD_SHIFT,
    activeDate: activeDate
  })
}



// WEBPACK FOOTER //
// ./src/actions/shifts.js